import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

import type { TextAlignment } from './types';
const { responsiveText, spacing } = theme;

export interface RatingBlockCSS extends CSSProperties {
  '--alignment': TextAlignment;
}

export const overallRatingContainer = css`
  width: 100%;
  text-align: var(--alignment);
  display: flex;
  flex-direction: column;
`;

export const ratingHeading = css`
  margin: 0;
  ${responsiveText.BODY.XS};
  font-weight: bold;
`;

export const overallRating = css`
  margin-left: ${spacing.base}px;
  ${responsiveText.BODY.MD};
  font-weight: bold;
`;

export const maximumRating = css`
  ${responsiveText.BODY.XS};
  font-weight: bold;
`;

export const ratingArea = css`
  display: flex;
  align-items: baseline;
  justify-content: var(--alignment);
  margin: 0 0 ${spacing.base}px;
`;
